export const MediaTypeAcceptType = {
	image: 'image/jpeg,image/jpg,image/png,image/webp',
	video: 'video/mp4',
	faceSwap: 'video/mp4,video/quicktime'
} as const;
